<template>


 <div>
    <h2>Personas en el Grupo</h2>
 </div>

 <div v-for="m in miembros" :key="m.id">
    <span v-bind:style="{ backgroundColor: m.color }">  {{m.user.name }} {{ m.user.apellido }} - {{ m.user.email}}</span>&nbsp;

    <FormKit
    type="button"
    @click="quitarUsuario(m.user)">

  <span class="fa fa-trash" aria-hidden="true"></span>
  </FormKit>

</div>




<div>
<p>----------------</p>
<h1>AÑADIR AL GRUPO DE TRABAJO</h1>

<FormKit
  type="email"
  label="Login del Usuario"
  help="Introduzca el email"
  v-model="email"
  validation="required|email|"
  validation-visibility="live"
/>


<FormKit
  type="color"
  value="#00FFFF"
  v-model="color"
  label="Selecciona un color"
  help="Color del calendario del grupo"
/>



<FormKit
    type="button"
    label="Añadir al grupo"
    @click="asignarUsuario()"

    />


</div>





</template>





<script>
import { throwStatement } from '@babel/types';



export default {
  props: ["grupos"],
  data() {
    return {
     grupo:0,
     email:"",
      color: "#0000FF",
      miembros:[],
      sacar_del_grupo:0,
    };
  },

  methods: {
    getUsuarios: function () {
      axios.get("/grupo_usuarios/get_usuarios/"+this.grupo)
      .then(
       response => {
          this.miembros = response.data;
        });
    },

    asignarUsuario: function () {

     axios.post("/grupo_usuarios/add_usuario", {
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          grupo:this.grupo,
          email:this.email,
          color:this.color,

        })
        .then(
            response=>{
            this.getUsuarios()}
        )
    },


    quitarUsuario: function (user) {
console.log(user)

        if (confirm(`Confirme que desea dar de baja de del grupo a  ${user.name} ${user.apellido}`)) {

            axios.delete("/grupo_usuarios/delete_usuarios/"+this.grupo+"/"+user.id)
                    .then(response => {
                        console.log('enviado ahora actualizar datos')
                        this.getUsuarios()



                    });




      }



    },




  },

  mounted() {

    this.grupo=this.grupos.id
this.getUsuarios()


  },
};
</script>
